
import { Component, Vue } from 'vue-property-decorator';
import { Toast } from "vant";
import { EmployerActivityService } from "src/services";

@Component({
    components: {}
})
export default class CouponList extends Vue {

    /**
     * 产品类型map
     * @private
     * @returns object
     */
    private productTypeMap: any = {
        physical: 2,    // 体检套餐
        goods: 4,       // 实物商品
        medical: 6,     // 医疗服务
        rights: 99      // 权益商品
    };

    /**
     * 优惠券适用商品类型map
     * @private
     * @returns object
     */
    private useTargetKindMap: any = {
        common: 2,      // 通用券
        physical: 4,    // 体检套餐
        goods: 6,       // 实物商品
        medical: 8,     // 医疗服务
        rights: 99      // 权益商品
    };
    

    /**
     * 优惠券类型map
     * @private
     * @returns object
     */
    private couponTypeMap: any = {
        fullReduce: 2,  // 满减
        discount: 4,    // 折扣
    };
    
    /**
     * 优惠券状态map
     * @private
     * @returns object
     */
    private couponStatusMap: any = {
        waitUsing: 2,   // 待使用
        used: 4,        // 已使用
        invalid: 6,     // 已失效
    }

    /**
     * 领取类型map
     * @private
     * @returns object
     */
    private receiveTypeMap: any = {
        all: 2,
        newCustomer: 4
    }
    
    /**
     * 搜索关键字
     * @private
     * @returns string
     */
    private filters: any =
    {
        key: '',
        targetKind: ""
    };

    /**
     * 优惠券信息
     * @private
     * @returns Object
     */
     private couponInfo: any = {};

    /**
     * 是否查询不到优惠券信息
     * @private
     * @returns boolean
     */
     private noCoupon: boolean = false;

    /**
     * tab选中
     * @private
     * @returns number | string
     */
    private active: number | string = "";

    /**
     * tab数组
     * @private
     * @returns array
     */
    private tabList: any = [];

    /**
     * 优惠券id
     * @private
     * @returns string
     */
     private get couponId(): string
    {
        return this.$route.query && (this.$route.query.id as string) || '';
    }
    
    /**
     * tab切换
     * @private
     * @returns void
     */
    private onTabChange(type: any): void
    {
        this.filters.targetKind = type;
        (this.$refs.myUPageList as any).onRefresh();
    }

    /**
     * 获取订单列表
     * @private
     * @returns void
     */
    private async loadData(parameter: any): Promise<any>
    {
        try
        {
            if (!this.active) {
                return;
            }
            let filters = Object.assign(this.filters, {id: this.couponId}, parameter);
            let { content: result } = await EmployerActivityService.instance.couponMyGet(filters);
            if(result.data)
            {
                this.couponInfo = result.data || {};
                this.noCoupon = false;
                // 权益产品全部请求，不分页请求
                if (this.active == this.useTargetKindMap.rights) {
                    return {
                        hasNextPages: false,
                        hasPrevPages: false,
                        pageIndex: 1,
                        pageSize: 999999,
                        totalCount: result.data.useRights.length,
                        totalPages: 1,
                        items: result.data.useRights
                    };
                }
                else {
                    return result.data.useTargets;
                }
            }
            else {
                this.noCoupon = true;
                return null;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 获取tabs数据
     * @private
     * @returns void
     */
    private async myGetUseTargetKind(): Promise<any>
    {
        try
        {
            let params = {id: this.couponId};
            let { content: result } = await EmployerActivityService.instance.myGetUseTargetKind(params);
            if(result.data)
            {
                this.tabList = result.data || [];
                this.active = result.data[0].targetProductKind || '';
                this.filters.targetKind = result.data[0].targetProductKind || '';
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    // 初始化页面获取数据
    protected async mounted() {
        await this.myGetUseTargetKind();
        if(this.$refs.myUPageList) {
            (this.$refs.myUPageList as any).onRefresh();
        }
    } 

    /**
     * 搜索
     */
    protected onSearch(): void
    {
        (this.$refs.myUPageList as any).onRefresh();
    }

    /**
     * 进店逛逛
     * @private
     * @returns void
     */
    private onGoHome(): void
    {
        this.$router.push({name: 'home'});
    }

    /**
     * 套餐详情
     * @private
     * @type 体检类型
     * @returns void
     */
    private onPhysicalPackage(item: any): any
    {
        // 体检套餐 PhysicalPackage = 0
        // 医疗服务 MedicalService = 2
        // 实物 Goods = 4
        // 健管服务 HealthManageService = 6
        // 问诊购药 DiagMedicine = 2002
        // 就医绿通 Greenway = 2004
        // 齿科服务 Dental = 2006
        // 眼科服务 Eye = 2008
        // 疫苗服务 Vaccine = 2010
        // 中医服务 TCM = 2012
        // 轻医美 MedicalBeauty = 2014

        if (this.active == this.useTargetKindMap.rights) {
            // 权益
            this.$router.push({name:"rights-shop-detail",query:{id: item.id}})
        }
        else if(item.productType == 0)
        {
            // 体检套餐
            this.$router.push({name: "package-detail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 4)
        {
            // 实物套餐
            this.$router.push({name: "goodsDetail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 8)
        {
            // 健康险产品
            this.$router.push({name: "healthInsuranceDetail", query:{id: item.targetId}});
        }
        else
        {
            // 医疗产品
            this.$router.push({name:"medical", query:{id:item.targetId, productId: item.id}});
        }
    }
}
